import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type {
  RawGetStatisticsHourlyParams,
  RawGetStatisticsDailyParams,
  RawGetStatisticsMonthlyParams,
  RawGetStatisticsRangeParams,
  RawStatisticsResponse,
} from '../types/statistics';
import type { RequestOptions } from '../types/common';

export function createStatisticsApi(http: Http) {
  return {
    async hourly(
      params?: RawGetStatisticsHourlyParams,
      options?: RequestOptions,
    ): Promise<RawStatisticsResponse> {
      const res = await http.get<RawStatisticsResponse>(endpoints.statistics.hourly, {
        params,
        signal: options?.signal,
      });
      return res.data;
    },

    async daily(
      params?: RawGetStatisticsDailyParams,
      options?: RequestOptions,
    ): Promise<RawStatisticsResponse> {
      const res = await http.get<RawStatisticsResponse>(endpoints.statistics.daily, {
        params,
        signal: options?.signal,
      });
      return res.data;
    },

    async monthly(
      params?: RawGetStatisticsMonthlyParams,
      options?: RequestOptions,
    ): Promise<RawStatisticsResponse> {
      const res = await http.get<RawStatisticsResponse>(endpoints.statistics.monthly, {
        params,
        signal: options?.signal,
      });
      return res.data;
    },

    async range(
      params: RawGetStatisticsRangeParams,
      options?: RequestOptions,
    ): Promise<RawStatisticsResponse> {
      const res = await http.get<RawStatisticsResponse>(endpoints.statistics.range, {
        params,
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
